import { createSlice } from "@reduxjs/toolkit";
import { ApiCall, ApiCallStatus, Resource } from "@myRedux/networkState";
import { RootState } from "@myRedux/store";
import { handleSliceRejectionDefault } from "@myRedux/handleSliceRejection";
import { postResourceFromRel } from "@myRedux/appAsyncThunkUtilities";

export interface UserResource extends Resource {
  userName: string,
  displayUserName?: string,
  email?: string,
  password: string
}

const initialState = {
  status: ApiCallStatus.Idle,
} as ApiCall;

export const createUserResourceAsync = postResourceFromRel<UserResource>(
  'user/postUser',
  'auth_user',
  true
);

export const userSlice = createSlice({
  name: 'userSlice',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createUserResourceAsync.pending, (state) => {
        state.status = ApiCallStatus.Loading;
      })
      .addCase(createUserResourceAsync.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
      })
      .addCase(createUserResourceAsync.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
        state.error = action.payload;
        handleSliceRejectionDefault(action);
      })
  },
});

export const selectSignUpUser = (state: RootState) => state.user.signUpUser;

export default userSlice.reducer;